
<div class="wrapper">
<header class="header navbar navbar-expand-md row">
		<h2 class="col col-sm-6">RTO Exam Preparation</h2>
		<div class="col col-sm-3"></div>
		<div class="login-btn col col-sm-3">
			<a><button class="btn-fill" (click)="ltbtnClick()"><p>LOGIN</p></button></a>
		</div>        
</header>

<div class="container1">
	<section class="content-head">
		<h1>Welcome to RTO LLR Exam Preparation</h1>
		<p>Best place to learn everything about LLR(Learning License Registration) exam and Practice till you become confident.</p>
	</section>
	<br>
	<div class="background1"></div>
	<!-- <div class="bg1-data">
		<h1>Question Book</h1>
		<img src=".\images\other\agenda.png" width="25%"><br>
		<a href="questionbook.html"><button class="btn-fill"><p>Read Questions</p></button></a>
	</div> -->
	<div class="background2"></div>
	<!-- <div class="bg2-data">
		<h1> Traffic Signals</h1>
		<img src=".\images\other\trafficlight.png" width="25%"><br>
		<a href="roadsign.html"><button class="btn-fill" onclick="question.html" onmouseover=""><p>Read Sign</p></button></a>
	</div> -->
	<div class="background3"></div>
	<!-- <div class="bg3-data">
		<h1>RTO Pattern Test</h1>
		<img src=".\images\other\test.png" width="25%"><br>
		<a href="regtest.html"><button class="btn-fill"><p>Start Test</p></button></a>
	</div> -->
	<div class="background4"></div>
	<!-- <div class="bg4-data">
		<h1>Custom Test</h1>
		<img src=".\images\other\checklist.png" width="25%"><br>
		<a href="customtest.html"><button class="btn-fill"><p>Start Test</p></button></a>
	</div> -->

	<div class="row btn-area">
		<div class="row col col-sm-6">
		<div class="bg1-data col col-md-6">
			<h1>Question Book</h1>
			<img src="../../../assets/HomeImg/agenda.png"><br>
			<button class="btn-fill" (click)="qbtnClick()"><p>Read Questions</p></button>
		</div> 
		<div class="bg2-data col col-md-6">
			<h1> Traffic Signals</h1>
			<img src="../../../assets/HomeImg/trafficlight.png" ><br>
			<button class="btn-fill" (click)="rbtnClick()"><p>Road Sign</p></button>
		</div>
		</div> 
		<div class="row col col-sm-6">
		<div class="bg3-data col col-md-6">
			<h1>RTO Pattern Test</h1>
			<img src="../../../assets/HomeImg/test.png" ><br>
			<button class="btn-fill" (click)="rtbtnClick()"><p>Start Test</p></button>
		</div> 
		<div class="bg4-data col col-md-6">
			<h1>Custom Test</h1>
			<img src="../../../assets/HomeImg/checklist.png" ><br>
			<button class="btn-fill" (click)="ctbtnClick()"><p>Start Test</p></button>
		</div> 
	</div>       
	</div>

</div>
<footer class="footer">        
	<h5>coyright &copy; 2020,MS-Creation</h5>
</footer>
